import QuizGroups from "../../components/fun_stuff/QuizGroups";
import QuizHeader from "../../components/fun_stuff/QuizHeader";
import LiveGameBtn from "../../components/fun_stuff/LiveGameBtn";
import Challenges from "../../components/fun_stuff/Challenges";
import Scoreboard from "../../components/fun_stuff/Scoreboard";
import Cheating from "../../components/fun_stuff/Cheating";

const QuizProfileScreen = () => {
  return (
    <>
      <QuizHeader profile={true} />

      <div className="profile-section d-flex justify-content-center">
        <LiveGameBtn />
      </div>

      <div className="profile-section">
        <Challenges />
      </div>

      <div className="profile-section">
        <QuizGroups />
      </div>

      <div className="profile-section">
        <Scoreboard />
      </div>

      <div className="profile-section d-flex justify-content-center">
        <Cheating />
      </div>
    </>
  );
};

export default QuizProfileScreen;
